import {useEffect, useState} from "react"
import {DataGrid} from "@mui/x-data-grid";
//import { GridColDef } from '@mui/x-data-grid';
import { Paper, Typography, Button, FormControl, InputLabel, Select, MenuItem} from "@material-ui/core"
import { makeStyles } from '@material-ui/core/styles';
import { fetchfavQuotes, fetchfavQuotesbyDest, fetchDest } from "../api/customerapi";

const useStyles = makeStyles((theme) => ({
    paper: {
      marginLeft: theme.spacing(10),
      marginRight: theme.spacing(10),
      marginBottom: theme.spacing(5),
      marginTop: theme.spacing(4),
      justifyContent: "center",
      backgroundColor: "#f8f8f8"
    },
    headertext: {
      marginTop: theme.spacing(2),
      marginBottom: theme.spacing(2),
  },
  
    button: {
      marginLeft: theme.spacing(1),
      marginRight: theme.spacing(4),
      width: theme.spacing(15),
      height: theme.spacing(6),
      marginTop: theme.spacing(2),
      marginBottom: theme.spacing(2),
      justifyContent: "center",
    },
}));

const Listquotedata = () => {

    const classes = useStyles();
    const width = window.innerWidth-200;
    //console.log(width);
    const columns = [
        { field: 'quote_id', 
      headerName: ' Quote ID', 
      width: width/12,
      cellClassName: "gridcell"
      //align:"center",
      //headerAlign:"center"
    },
        { field: 'quote_name', 
        headerName: ' Quote Name', 
        width: width/12*3,
        cellClassName: "gridcell"
        //align:"center",
        //headerAlign:"center"
        },
        { field: 'quote_identifier', 
        headerName: ' Quote Identifier', 
        width: width/12*2,
        cellClassName: "gridcell"
        //align:"center",
        //headerAlign:"center"
        },
        {
          field: 'quote_dest',
          headerName: 'Destination',
          width: width/12*2,
          
        },
        {
          field: 'tour_duration',
          headerName: 'Duration',
          width: width/12,
        },
        {
          field: 'internal_notes',
          headerName: 'Notes',
          width: width/12*3,
        },
        
      ];
      
      const [dest, setdest]=useState([])
      const [leadfilterData, setleadfilterData]=useState({
        website:"",
        destination:""
      })
      const [listquoteData, setlistquoteData] =useState([{
        quote_header: "",
        
        internal_notes: "",
        tour_duration: "",
        primary_destination: "",
        
        }]);
      
      const loadquotes = async () => {
        try{
        if(leadfilterData.destination=="" || leadfilterData.destination==null || leadfilterData.destination=="All" ) {
          const data = await fetchfavQuotes();
          //console.log(data);
          //const custdatalistfromdb= data.data
          setlistquoteData(data.data)
          }else{
            const data = await fetchfavQuotesbyDest(leadfilterData.destination);
          //console.log(data);
          //const custdatalistfromdb= data.data
          setlistquoteData(data.data)
        
          }
        }catch(err){
          console.log(err)
        }
        //console.log(data);
        //const custdatalistfromdb= data.data
        
      
      }

      const getDest = async () => {
        try{
        const data = await fetchDest();
        const temp=data.data.filter(d=>"order" in d)
        setdest(temp[0].dest);
      }catch(err){
        console.log(err)
      }
      }
      
      useEffect(() => {
        getDest()
        
      }, [])

      var l1=[...listquoteData]
      if(leadfilterData.website){
        l1=l1.filter(q=>q.website)
      }

      const quotedatalistdisplay=l1.map(quotedata=>({quote_name: quotedata.quote_header, 
        id:listquoteData.indexOf(quotedata),
        quote_id:quotedata.quote_id, 
        quote_dest:quotedata.primary_destination, 
        quote_identifier:quotedata.quote_identifier,
        tour_duration:quotedata.duration, 
        tinternal_notes:quotedata.internal_notes }));
      //console.log(custdatalistfromdb);
    
      const gridcelldoubleclick=(id)=>{
        //window.location = ("/quotedataentry/"+id);
        window.open("/quotedataentry/"+id, "_blank");
        //console.log("/custdataentry/"+id);
      }

    return ( 
      <div>
      {dest.length>0 ?(
            <Paper variant="outlined" className={classes.paper}> 
        <div align="center">
        <Typography variant="h4" align="center" className={classes.headertext}> View Favorite Quotes</Typography>
        <FormControl style={{minWidth: 480, marginTop: 16, marginRight: 32, marginLeft: 8}}>
            <InputLabel id="Destination">Destination</InputLabel>
                <Select displayEmpty className={classes.textField} InputLabelProps={{ shrink: true }} labelId="Destination" value={leadfilterData.destination} onChange={(e)=> setleadfilterData({...leadfilterData, destination: e.target.value})}>
                
                {dest.map((dest) => {
                return <MenuItem value={dest}>{dest}</MenuItem>;
              })}
                    
                    
                
                </Select>
                </FormControl>
                
                <Button onClick={loadquotes} variant="contained"  color="inherit" className={classes.button}>Load</Button>
        </div>
        {/* {open ? <Modal open={open} onClose={handleClose}>abc</Modal> : <Modal open={open} onClose={handleClose}>def</Modal>} */}
        <div style={{ height: 1200, width: '100%' }}>
      <DataGrid rows={quotedatalistdisplay} 
        onCellDoubleClick={(getValue)=>gridcelldoubleclick(getValue.row.quote_id)}
        columns={columns}
        autoPageSize
        // pageSize={20}
        // rowHeight={50}
        
        // autoHeight
        >      
      </DataGrid>      
    </div>
    </Paper>
    ):("Loading...")}
    </div>
     );
}
 
export default Listquotedata;